// tslint:disable
import { clone, get } from 'lodash';
import * as React from 'react';
import { InputField } from '../../components/fields/input.field';
import { IriField } from '../../components/fields/iri.field';
import { TextAreaField } from '../../components/fields/textarea.field';
//import { MediaItemField } from '../../components/fields/media-item.field';
import { WysiwygField } from '../../components/fields/wysiwyg.field';
import { Field, FormLib } from '../../components/libs/form.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { Validators } from '../../components/libs/Validators';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { IriPresenter } from '../../components/structurals/presenters/iri-presenter';
import { ListResponsePresenterTable } from '../../components/structurals/presenters/list-response-presenter-table';
import { ResourceModal } from '../../components/structurals/resource-modal';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';

export class DefaultModalCompanyPage extends React.Component<any, any> {

    public state: any = {
        albums: []
    };

    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {
        if (!this.state.albums.length) {
            form.fields.album.setValue([]);
        }

        this.executor.updateEndPoint('company-page');
        form.fields.company.registerField();
        form.fields.company.setValue(this.props.CONFIG.company);
        form.fields.companySiteSpec.registerField();
        form.fields.companySiteSpec.setValue(this.props.CONFIG.companySiteSpec);

        this.executor.updateForm(form);
        await this.executor.exec();
    }

    public handleFormArrive(form: FormLib) {
        const albumField: Field = form.fields.album;
        albumField.registerField();
        albumField.onValueChanges$.subscribe((v: any) => {
            this.setState({
                albums: v.map((i: any) => this.toIri(i))
            });
        });
    }

    public handleAlbumCreated(form: FormLib, album: any) {
        const albumField: Field = form.fields.album;
        const albums = clone(albumField.value);
        const newAlbumIri = this.toIri(album);
        albums.push(newAlbumIri);
        albumField.setValue(albums.map((i: any) => this.toIri(i)));
        this.setState({
            albums: albums || []
        });
    }

    render() {
        return (
            <ResourceLoader entity="company-page" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div>
                {this.handleFormArrive(form)}
                <div className="row">
                    <div className="col-xs-12">
                        <div className="alert alert-warning">
                            This page is only shown when the company is a Member type.
                        </div>
                    </div>
                </div>
                <LoaderComponent isLoading$={this.executor.loading$}/>
                <div className="realtive col-xs-12">
                    <ToggleBoxComponent title={this.props.IS_CREATE ? 'Create new Page to the Company' : 'Edit page'} color='green' alwaysOpen={true} preIcon="fa-edit">
                        <div className="row">
                            <div className="col-xs-12">
                                <IriField
                                    title="Page type"
                                    field={form.fields.type}
                                    defaultAll={true}
                                    validators={[Validators.required('Required')]}
                                />
                                <InputField
                                    field={form.fields.title}
                                    validators={[
                                        Validators.required('Required')
                                    ]}/>

                                <WysiwygField
                                    title='Body'
                                    field={form.fields.body}
                                />


                                <TextAreaField
                                    field={form.fields.widgetyId}
                                />
                            </div>
                        </div>
                    </ToggleBoxComponent>

                    <ToggleBoxComponent title='Albums' alwaysOpen={true} preIcon="fa-image">

                        <ListResponsePresenterTable
                            items={this.state.albums || []}
                            head={() => <tr>
                                <th>Name</th>
                                <th style={{width: '1%'}}/>
                            </tr>}
                            row={(item: any, index: number) => item && item.replace && <tr key={index}>
                                <td>
                                    <IriPresenter iri={item} path={'title'}/>
                                </td>
                                <td>
                                    <div className="btn-group btn-group-sm resource-modal-fixup">
                                        <ResourceModal
                                            entity='media-album' entityId={item && item.replace('/media-album/', '')} title={'Edit Album'}
                                        />
                                        <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                                            <span className="sr-only">Toggle Dropdown</span>
                                        </button>
                                        <ul className="dropdown-menu" role="menu">
                                            <li>
                                                <a>Delete Album</a>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>}
                        />

                        <ResourceModal
                            entity={'media-album'}
                            entityId={'create'}
                            title={'Add new album'}
                            onCreateSuccessful={(event: any) => this.handleAlbumCreated(form, event)}
                        />

                    </ToggleBoxComponent>

                    <div className="col-xs-12">
                        <div className='col-xs-12'>
                            <button className='btn btn-primary pull-left' onClick={() => this.saveForm(form)}>Save</button>
                        </div>
                    </div>

                </div>
            </div>}/>
        );
    }

    private toIri(raw: any) {
        if (get(raw, '@id')) {
            return get(raw, '@id');
        } else {
            return raw;
        }
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.modal.company-page.tsx